<template>
  <DetailsPageTitle :title="$t('static.privacy.title')"></DetailsPageTitle>
  <div dir="ltr" class="paper">
    <p>
      At Taza and the terms “we”, “our” and “us” refer to Taza, we recognize and
      respect the importance of maintaining the privacy of our customers, and as
      a result, we have established this Privacy Policy. This Privacy Policy
      describes the types of information we collect from and about you when you
      visit our website, Tazaaraiba.com This Privacy Policy also explains how
      Taza may use and disclose such information, as well as your ability to
      control certain uses of it.
    </p>
    <h4>SUMMARY</h4>
    <ListedText
      :content="'We may collect personal information including your name, address, email address, telephone or mobile number, user name and password, geolocation information, and, if you make a purchase on the Platform, your payment information, as well as non-personal information about your use of the Platform.'"
      :bold-content="'Information Collection.'"
    />
    <ListedText
      :content="'We may use the information we collect from and about you for purposes including to provide you with Platform services, provide you with targeted offers and advertising on our site, other sites you may visit, and through other channels such as email, postal mail, or text message, and contact you when necessary.'"
      :bold-content="'Information Use.'"
    />
    <ListedText
      :content="'We may collect personal information including your name, address, email address, telephone or mobile number, user name and password, geolocation information, and, if you make a purchase on the Platform, your payment information, as well as non-personal information about your use of the Platform.'"
      :bold-content="'Information Collection.'"
    />
    <p>
      Note: You must be 18 years or older to register as a customer of
      (<span>shop@Tazaarabia.com</span>)
    </p>
    <h4>INFORMATION COLLECTION</h4>
    <ListedText :bold-content="'Information We Automatically Collect'" />
    <p>
      We may use cookies, web beacons, pixel tags, log files, or other
      technologies to automatically collect certain information when you use our
      Platform. For example, we may automatically collect certain non-personal
      information from you such as your browser type, operating system, software
      version, Internet Protocol (“IP”) address, phone model, phone operating
      system, and carrier information.
    </p>
    <p>
      We also may collect information about your use of the Platform including
      the date and time you access the Platform, the areas or pages of the
      Platform that you visit, the amount of time you spend using the Platform,
      the number of times you return, broad demographic information, whether you
      open forward or click-through emails and ads, and other Platform usage
      data.
    </p>
    <ListedText :bold-content="'Tracking Options'" />
    <p>
      Certain parts of our Platform require cookies. You are free to set your
      browser or operating system settings to limit certain tracking or to
      decline cookies, but by doing so, you may not be able to use certain
      features on the Platform or take full advantage of all of our offerings.
      Check the “Help” menu of your browser, device, or operating system for
      more information on how to delete and/or disable your browser or operating
      system from receiving cookies or controlling your tracking preferences.
    </p>
    <ListedText :bold-content="'Information Collected from Other Sources'" />
    <p>
      We may obtain information about you from other sources, including social
      networks that you use to connect with Taza or other Taza customers such as
      when they purchase a gift card for you. This information may include name,
      user name, demographic information, updated address or contact
      information, interests, and publicly-observed data, such as from social
      media and online activity. We may combine this information with the
      information we collect from and about you to help us tailor our
      communications to you and to improve our Platform.
    </p>
    <h4>INFORMATION USE</h4>
    <p>
      Taza may use the information we collect from and about you for any of the
      following purposes:<br /><br />

      1. To respond to your inquiries or requests, process and fill customer
      orders, verify your qualifications for certain products and services,
      process payments and prevent transactional fraud, provide delivery and
      other notifications, and contact and communicate with you;<br />
      2. To develop new products or services and to conduct analysis to enhance
      current products and services;<br />
      3. To provide you with customized Platform content, targeted offers, and
      advertising on the Platform, on other third-party sites or apps you may
      visit, or via email;<br />
      or contact you with information, newsletters and promotional materials
      from Taza through various channels including but not limited to online,
      email, postal mail, and text message;<br /><br />

      4. To contact you when necessary;<br />
      5. To review the usage and operations of our Platform, improve our
      content, products, and services, or address problems with the Platform or
      our business;<br />
      6. To use your data in an aggregated non-specific format for analytical
      and demographic purposes;<br />
      7. To manage our telecommunications networks;<br />
      8. To protect the security or integrity of the Platform and our business;
      and<br />
      9. As otherwise described to you at the point of data collection.<br />
    </p>
    <ListedText :bold-content="'How to Limit Our Use of Certain Information'" />
    <p>
      Users of our Platform are given the opportunity to “opt out” of having
      their information used for purposes not directly related to placement,
      processing, fulfilment or delivery of a product order at the point where
      we ask for the information. If you prefer to “opt out” and not have us
      send you material we think may be of interest to you, such as product
      information, product samples, and promotional mailings/e-mails from us and
      sites and companies we own, then you can notify us in one of the following
      two ways:
    </p>

    <p>
      1. E-mailing us at (<span>shop@Tazaarabia.com</span>) and include your
      mailing address.<br />
      2. Contact our service desk (00962799292794), during our working hours and
      include your mailing address.
    </p>
    <p>
      Your instructions to limit the use of your information will be processed
      as soon as reasonably practicable. In addition, you may “opt out” by
      accessing and updating your information in the “Your Account” section on
      the Platform.
    </p>
    <h4>INFORMATION DISCLOSURE</h4>
    <p>
      Taza may disclose the information we collect from and about you as
      follows: (1) to our Service Providers, if the disclosure will enable them
      to perform a business, professional or technical support function for us,
      including to the extent necessary or desirable to fulfil or ship your
      order or complete your transaction; (2) to our selected partners,
      affiliates, and other third parties that we believe may have offers of
      interest to you; (3) as necessary if we believe that there has been a
      violation of the (store name) Platform Terms of Use, Customer Agreement,
      or of our rights or the rights of any third party; (4) to respond to
      judicial process or provide information to law enforcement or regulatory
      agencies or in connection with an investigation on matters related to
      public safety, as permitted by law, or otherwise as required by law; and
      (5) as otherwise described to you at the point of collection.
      <br /><br />
      Further, Taza may share aggregate or anonymous non-personal information
      with third parties for their marketing or analytics uses.
    </p>
    <h4>SERVICE PROVIDERS</h4>
    <p>
      Taza may contract with third parties to perform functions related to the
      Platform. Service Providers will have access to your information needed to
      perform their business functions but may not use or share that information
      for other purposes.
    </p>
    <h4>LINKS TO OTHER WEBSITES</h4>
    <p>
      Our Platform may contain links to other third-party websites or
      applications, which likely have privacy policies that differ from our own.
      We are not responsible for the practices of such sites or applications.
    </p>
    <h4>OUR COMMITMENT TO DATA SECURITY</h4>
    <p>
      We have taken certain physical, administrative, and technical steps to
      safeguard the information we collect from and about our customers and
      Platform visitors. While we make every effort to help ensure the integrity
      and security of our network and systems, remember that no method of
      transmission over the Internet or method of electronic storage is 100%
      secure.
    </p>
    <h4>ACCESS TO YOUR PERSONAL INFORMATION</h4>
    <p>
      To update your account, you may sign in to “Your Account” on the Platform
      and update your personal information. In addition, if any of your personal
      information changes, or if you no longer desire to use our service, we can
      correct, update, or remove the personal information provided to us. This
      can be done by sending an e-mail with your new information to
      (<span>shop@Tazaarabia.com</span>), and specifying the information to be
      corrected, updated, or removed. Please do not send credit or debit card
      information by email.
    </p>
    <h4>IF YOU HAVE QUESTIONS</h4>
    <p>
      If you have any questions, feedback, or concerns about this Privacy Policy
      or the practices described herein, you may contact us at
      (<span>shop@Tazaarabia.com</span>).
    </p>
    <h4>USER’S ACCEPTANCE OF THIS PRIVACY POLICY</h4>
    <p>
      By visiting the Platform, you signify your acceptance to the terms of Taza
      Privacy Policy. If you do not agree with the terms of this Privacy Policy,
      please do not use the Platform. We reserve the right, at our sole
      discretion, to change, modify, add or remove portions from this Privacy
      Policy at any time. Your continued use of the Platform following the
      posting of changes to these terms means you accept these changes.
    </p>
    <h4>REVISIONS TO THIS POLICY</h4>
    <p>
      Taza reserves the right to revise this Privacy Policy at any time. When we
      do, we will post the change(s) on the Platform. If we change the Privacy
      Policy in a material way, we will provide appropriate notice to you.
    </p>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
